export default "<div #mapSelector class=\"dashboard-users-map {{chartClass || ''}}\"></div>\n"